import React from "react";
import { History } from "history";

export const HistoryContext = React.createContext<History | null>(null);
